<template>
  <EditDataRepairsLayout>
    <div class="wrapper col-md-6">
      <table class="col-md-12">
        <tbody>
          <tr>
            <td>комментарий</td>
            <td>
              <textarea
                rows="3"
                class="form-control form-control-sm input-form shadow-none"
                v-model="comment"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-sm btn-outline-success shadow-none" @click="save">
        сохранить
      </button>
      <button class="btn btn-sm btn-outline-danger shadow-none" @click="cancel">
        отмена
      </button>
    </div>
  </EditDataRepairsLayout>
</template>
<script>
import EditDataRepairsLayout from "@/layouts/EditDataRepairsLayout.vue";
import { HTTPGET } from "@/api";
export default {
  name: "EditComment",
  props: ["data"],
  components: {
    EditDataRepairsLayout
  },
  data: () => ({
    comment: null
  }),
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    save() {
      if (this.comment === this.data.comment) {
        this.$emit("cancel");
        return;
      }
      HTTPGET({
        url: "repairs/repair_edit/edit_repair_comment.php",
        params: {
          comment: this.comment,
          id: this.data.remont_id
        }
      }).then(() => this.$emit("cancel"));
    }
  },
  mounted() {
    this.comment = this.data.comment;
  }
};
</script>
<style lang="scss" scoped>
td {
  padding: 3px;
}
.wrapper {
  padding: 15px;
  background: white;
  border: 1px solid #ced4da;
  border-radius: 3px;
  display: table;
  margin: auto;
}
.btn {
  margin-right: 15px;
  margin-top: 10px;
}
</style>
